import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  DtpContent,
  DtpSnackbar,
} from 'dtp-react-components';
import { Modal } from 'react-overlays';
import RequerimentoAposentadoria from './pages/requerimentos/Aposentadoria/RequerimentoAposentadoria';
import RequerimentoPensao from './pages/requerimentos/Pensao/RequerimentoPensao';
import RequerimentoCessacao from './pages/requerimentos/Cessacao/RequerimentoCessacao';
import Consulta from './pages/consultas/Consulta';
import Indeferido from './pages/requerimentos/Indeferido/Indeferido';
import ConsultaCronogramaPagamentos from './pages/consultas/ConsultaCronogramaPagamentos';
import {
  Footer,
  Header,
  Spinner,
} from './components/index';
import AuthenticationProvider from './components/ComponentesAutenticacao/AuthenticationProvider';
import PrivateRoute from './components/ComponentesAutenticacao/PrivateRoute';
import AuthContext from './components/ComponentesAutenticacao/Provider';
import ValorMedioBeneficio from './pages/cadastros/ValoresMediosBeneficios/ValorMedioBeneficio';
import ConsultaCessacaoBeneficio from './pages/consultas/ConsultaCessacaoRequerimento';
import ConsultaBloqueio from './pages/consultas/ConsultaBloqueio';
import BloqueioDesbloqueioEnte from './pages/cadastros/EntesFederativos/BloqueioDesbloqueio/BloqueioDesbloqueioEnte';
import ConsultaPrisma from './pages/consultas/ConsultaPrisma';
import ConsultaGlosaDeDacao from './pages/glosas/ConsultaGlosaDeDacao';
import CadastroGlosaDeDacao from './pages/glosas/CadastroGlosaDeDacao';
import RegimeProprio from './pages/cadastros/EntesFederativos/Rpps/RegimeProprio';
import ConsultaEnteFederativo from './pages/consultas/ConsultaEnteFederativo';
import ConsultaPagamentos from './pages/consultas/ConsultaPagamentos';
import ConsultaAuditoria from './pages/consultas/ConsultaAuditoria';
import ConsultaFilaGet from './pages/consultas/ConsultaFilaGet';
import ConsultaOperacoesGet from './pages/consultas/ConsultaOperacoesGet';
import ControlePagamentos from './pages/controle-pagamento/ControlePagamentos';
import './App.css';
import TelaRelatorioPagamentos from './pages/relatorios/TelaRelatorioPagamentos';
import TelaRelatorioRequerimentos from './pages/relatorios/TelaRelatorioRequerimentos';
import Inicio from './pages/Inicio';
import Mensagens from './pages/mensagens/Mensagens';
import OrgaosVinculadosUniao from './pages/cadastros/OrgaosVinculadosUniao/CadastroOrgaosVinculados';
import PeriodosRppsUniao from './pages/cadastros/PeriodosRppsUniao/CadastroPeriodos';
import AcrescimosLegais from './pages/acrescimos-legais/Calculadora';
import DetalhePagamento from './pages/controle-pagamento/DetalhePagamento';
import CronogramaPagamento from './pages/cadastros/cronograma-pagamentos/CronogramaPagamento';
import ConsultaCpf from './pages/consulta-cpf/ConsultaCpf';
import Conversor from './pages/conversor-amd/Conversor';
import InfoCronogramaVisualCompetencia from './pages/cadastros/cronograma-pagamentos/InfoCronogramaVisualCompetencia';
import Calculador from './pages/calculador-amd/Calculador';
import TelaRelatorioTotalizadorEstados from './pages/relatorios/TelaRelatorioTotalizadorEstados';
import TelaRelatorioAnalitico from './pages/relatorios/TelaRelatorioAnalitico';
import Logotipo from './pages/Logotipo';
import TelaRelatorioTotalizadorExigencias from './pages/relatorios/TelaRelatorioTotalizadorExigencias';
import TelaRelatorioExigenciaAnalitico from './pages/relatorios/TelaRelatorioExigenciaAnalitico';
import RepositorioCtc from './pages/repositorio-ctc/RepositorioCtc';

import ConsultaSimulacaoCompensacao from './pages/relatorios/ConsultaSimulacaoCompensacao';
import CalculadoraPeriodos from './pages/calculadora-periodos/CalculadoraPeriodos';
import ConsultaExtratoCnis from './pages/consultas/ConsultaExtratoCnis';

import ConsultaRepositorioCtc from './pages/repositorio-ctc/ConsultaRepositorioCtc';


const HeaderWithRouter = withRouter(props => <Header {...props} />);

const App = props => (
  <Router>
    <React.Fragment>
      <Modal
        backdropClassName="dtp-modal-backdrop"
        containerClassName="dtp-modal-container"
        show={props.showLoading}
      >
        <Spinner show divClass="loading" />
      </Modal>
      <AuthenticationProvider>
        <AuthContext.Consumer>
          {auth => (
            <HeaderWithRouter userData={auth.userData} />
          )}
        </AuthContext.Consumer>
        <DtpContent>
          {window.comprevConfigLogotipo.exibirLogo === 1 ? <Logotipo /> : '' }
          {/* Rotas possíveis para requerimento de aposentadoria */}
          <Switch>
            <PrivateRoute
              exact
              path="/requerimento/aposentadoria/novo"
              component={RequerimentoAposentadoria}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              exact
              path="/requerimento/aposentadoria/:protocolo"
              component={RequerimentoAposentadoria}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps', 'fornecer-parecer-medico-rpps',
              'analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'analisar-negocio-dtpv',
              'consultar-compensacao-rpps', 'consultar-compensacao-rgps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/requerimento/aposentadoria/:protocolo/:acao(cumprir-exigencia|realizar-analise|emitir-parecer-medico|qualificar)"
              component={RequerimentoAposentadoria}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps', 'fornecer-parecer-medico-rpps',
              'analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'analisar-negocio-dtpv']}
            />
            {/* Rotas possíveis para requerimento de pensao */}
            <PrivateRoute
              exact
              path="/requerimento/pensao/novo"
              component={RequerimentoPensao}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              exact
              path="/requerimento/pensao/:protocolo"
              component={RequerimentoPensao}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps', 'fornecer-parecer-medico-rpps',
              'analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'analisar-negocio-dtpv',
              'consultar-compensacao-rpps', 'consultar-compensacao-rgps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/requerimento/pensao/:protocolo/:acao(cumprir-exigencia|realizar-analise|emitir-parecer-medico)"
              component={RequerimentoPensao}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps', 'fornecer-parecer-medico-rpps',
              'analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'analisar-negocio-dtpv']}
            />
            {/* Rotas possíveis para consulta de requerimentos */}
            <PrivateRoute
              exact
              path="/consulta/:regime(rpps|rgps)"
              component={Consulta}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rpps', 'consultar-compensacao-rgps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/consulta/:tipoConsulta(exigencia|analise|parecer-medico|prescricao-exigencia)/:regime(rpps|rgps)"
              component={Consulta}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps', 'fornecer-parecer-medico-rpps',
              'gerenciar-negocio-dcomp']}
            />
            {/*
              Um requerimento Indeferido não está relacionado a Exigência, mas para que
              o menu dê um highlight foi necessário colocar o path com o texto exigencia
            */}
            <PrivateRoute
              path="/exigencia/indeferidos/:regime(rpps|rgps)"
              component={Indeferido}
              permissionsAllowed={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rpps']}
            />
            <PrivateRoute
              path="/requerimento/aposentadoria/:protocolo/:acao(indeferidos)"
              component={RequerimentoAposentadoria}
              permissionsAllowed={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rpps']}
            />
            <PrivateRoute
              path="/requerimento/pensao/:protocolo/:acao(indeferidos)"
              component={RequerimentoPensao}
              permissionsAllowed={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rpps']}
            />
            <PrivateRoute
              exact
              path="/cadastros/valoresMediosBeneficios/novo"
              component={ValorMedioBeneficio}
              permissionsAllowed={['requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
              'analisar-compensacao-rgps', 'analisar-negocio-sprev', 'gerenciar-negocio-dcomp',
              'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              exact
              path="/consultaCessacaoRequerimento/:tipoConsulta(cessacao-requerimento)"
              component={ConsultaCessacaoBeneficio}
              permissionsAllowed={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'analisar-compensacao-rpps',
              'requerer-compensacao-rpps', 'analisar-negocio-sprev', 'gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              path="/requerimento/cessacao/:tipoRequerimento/:protocolo/:acao(cessar-requerimento)"
              component={RequerimentoCessacao}
              permissionsAllowed={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'analisar-compensacao-rpps',
              'requerer-compensacao-rpps', 'analisar-negocio-sprev', 'gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              exact
              path="/consultaBloqueio/:tipoConsulta(bloqueio)"
              component={ConsultaBloqueio}
              permissionsAllowed={['gerenciar-negocio-dcomp', 'analisar-negocio-sprev', 'analisar-contrato-dtpv']}
            />
            <PrivateRoute
              path="/cadastros/entesFederativos/bloqueio/:acao(desbloquear-ente)/:chave/:mes/:ano/:tipo/"
              component={BloqueioDesbloqueioEnte}
              permissionsAllowed={['gerenciar-negocio-dcomp', 'analisar-negocio-sprev', 'analisar-contrato-dtpv']}
            />
            <PrivateRoute
              path="/cadastros/entesFederativos/bloqueio/:chave/:tipoEntidade/:uf/:codigo"
              component={BloqueioDesbloqueioEnte}
              permissionsAllowed={['gerenciar-negocio-dcomp', 'analisar-negocio-sprev', 'analisar-contrato-dtpv']}
            />
            <PrivateRoute
              path="/cadastros/entesFederativos/bloqueio/:chave"
              component={BloqueioDesbloqueioEnte}
              permissionsAllowed={['gerenciar-negocio-dcomp', 'analisar-negocio-sprev', 'analisar-contrato-dtpv']}
            />
            <PrivateRoute
              exact
              path="/consultaGlosaDeDacao/:tipoConsulta(consulta-glosa)"
              component={ConsultaGlosaDeDacao}
              permissionsAllowed={['gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              path="/cadastros/glosaDeDacao/:idglosa?"
              component={CadastroGlosaDeDacao}
              permissionsAllowed={['gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              exact
              path="/consultaPrisma/:tipoConsulta(consulta-prisma)"
              component={ConsultaPrisma}
              permissionsAllowed={['analisar-compensacao-rgps', 'gerenciar-negocio-dcomp', 'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              exact
              path="/consultaFilaGet/:tipoConsulta(consulta-filaget)"
              component={ConsultaFilaGet}
              permissionsAllowed={['analisar-negocio-dtpv', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp', 'analisar-negocio-sprev']}
            />
            <PrivateRoute
              exact
              path="/consultaOperacoesGet/consulta-operacoes-get"
              component={ConsultaOperacoesGet}
              permissionsAllowed={['analisar-negocio-dtpv', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              exact
              path="/consultaOperacoesGet/:idTarefaGet"
              component={ConsultaOperacoesGet}
              permissionsAllowed={['analisar-negocio-dtpv', 'analisar-compensacao-rgps', 'gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              exact
              path="/consultaEnteFederativo/:tipoConsulta(consulta-rpps)"
              component={ConsultaEnteFederativo}
              permissionsAllowed={['requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'consultar-compensacao-rgps',
              'auditar-comprev', 'analisar-negocio-dtpv', 'requerer-compensacao-rgps', 'requerer-compensacao-rpps']}
            />
            <PrivateRoute
              path="/cadastros/entesFederativos/rpps/:idParticipante/:acao(atualizar-rpps)"
              component={RegimeProprio}
              permissionsAllowed={['requerer-compensacao-rpps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rpps', 'consultar-compensacao-rgps',
              'auditar-comprev', 'analisar-negocio-dtpv', 'requerer-compensacao-rgps', 'requerer-compensacao-rpps']}
            />
            <PrivateRoute
              path="/consulta/consultaPagamentos"
              component={ConsultaPagamentos}
              permissionsAllowed={['gerenciar-negocio-dcomp']}
            />
            <PrivateRoute
              path="/consultaAuditoria/auditoria"
              component={ConsultaAuditoria}
              permissionsAllowed={['analisar-negocio-sprev', 'gerenciar-negocio-dcomp', 'consultar-compensacao-rpps',
              'consultar-compensacao-rgps', 'auditar-comprev', 'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              exact
              path="/relatorios/pagamentos"
              component={TelaRelatorioPagamentos}
              permissionsAllowed={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              exact
              path="/relatorios/requerimentos"
              component={TelaRelatorioRequerimentos}
              permissionsAllowed={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              exact
              path="/"
              component={Inicio}
              permissionsAllowed={['requerer-compensacao-rgps', 'analisar-compensacao-rgps', 'analisar-compensacao-rpps',
              'requerer-compensacao-rpps', 'fornecer-parecer-medico-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rpps', 'consultar-compensacao-rgps',
              'auditar-comprev', 'analisar-negocio-dtpv', 'analisar-contrato-dtpv']}
            />
            <PrivateRoute
              exact
              path="/mensagens/novo"
              component={Mensagens}
              permissionsAllowed={['analisar-negocio-dtpv', 'analisar-negocio-sprev']}
            />
            <PrivateRoute
              path="/cadastros/OrgaosVinculadosUniao"
              component={OrgaosVinculadosUniao}
              permissionsAllowed={['analisar-negocio-sprev', 'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/cadastros/PeriodosRppsUniao"
              component={PeriodosRppsUniao}
              permissionsAllowed={['analisar-negocio-sprev', 'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/controledepagamentos/home/:tipoControle(controle-pagamentos|controle-debitos-pendentes|pendencias)"
              component={ControlePagamentos}
              permissionsAllowed={['gerenciar-negocio-dcomp', 'requerer-compensacao-rpps',
              'analisar-compensacao-rpps', 'analisar-negocio-sprev', 'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/controledepagamentos/home/:visaoRota/:tipoControle(controle-pagamentos|controle-debitos-pendentes|pendencias)"
              component={ControlePagamentos}
              permissionsAllowed={['gerenciar-negocio-dcomp', 'requerer-compensacao-rpps',
              'analisar-compensacao-rpps', 'analisar-negocio-sprev', 'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/controledepagamentos/detalhe/:idControlePagamento/:tipoControle(controle-pagamentos|controle-debitos-pendentes|pendencias)"
              component={DetalhePagamento}
              permissionsAllowed={['gerenciar-negocio-dcomp', 'requerer-compensacao-rpps',
              'analisar-compensacao-rpps', 'analisar-negocio-sprev', 'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/relatorios/simulacaocompensacao"
              component={ConsultaSimulacaoCompensacao}
              permissionsAllowed={['auditar-comprev', 'analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/cadastros/cronogramaPagamento"
              component={ConsultaCronogramaPagamentos}
              permissionsAllowed={['analisar-negocio-sprev']}
            />
            <PrivateRoute
              exact
              path="/cadastros/cronograma-pagamento/:mes/:ano/:acao(novo)"
              component={CronogramaPagamento}
              permissionsAllowed={['analisar-negocio-sprev']}
            />
            <PrivateRoute
              exact
              path="/cadastros/cronograma-pagamento/detalhe/:mes/:ano/:acao(detalhar|alterar)"
              component={CronogramaPagamento}
              permissionsAllowed={['analisar-negocio-sprev']}
            />
            <PrivateRoute
              exact
              path="/cadastros/cronograma-pagamento/visualizar-cronogramas/:mes1/:ano1/:mes2/:ano2/:mes3/:ano3"
              component={InfoCronogramaVisualCompetencia}
              permissionsAllowed={['analisar-negocio-sprev']}
            />
            <Route
              path="/calculadora/acrescimos-legais"
              component={AcrescimosLegais}
            />
            <Route
              path="/consulta-cpf/consultacpf"
              component={ConsultaCpf}
            />
            <Route
              path="/conversor-amd/conversor"
              component={Conversor}
            />
            <Route
              path="/calculador-amd/calculador"
              component={Calculador}
            />
            <Route
              path="/calculadora-periodos/calculadoraperiodos"
              component={CalculadoraPeriodos}
            />
            <PrivateRoute
              exact
              path="/relatorios/totalizador/estados"
              component={TelaRelatorioTotalizadorEstados}
              permissionsAllowed={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              exact
              path="/relatorios/estado/tipo"
              component={TelaRelatorioAnalitico}
              permissionsAllowed={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              exact
              path="/relatorios/estado/exigencias"
              component={TelaRelatorioTotalizadorExigencias}
              permissionsAllowed={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/consulta/:tipoConsulta(complementar-aposentadoria)/:regime(rpps|rgps)"
              component={Consulta}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps']}
            />
            <PrivateRoute
              path="/requerimento/aposentadoria/:protocolo/:acao(complementar-aposentadoria)"
              component={RequerimentoAposentadoria}
              permissionsAllowed={['requerer-compensacao-rgps', 'requerer-compensacao-rpps', 'analisar-compensacao-rgps',
              'analisar-compensacao-rpps']}
            />
            <PrivateRoute
              path="/relatorios/estado/exigencias/analitico"
              component={TelaRelatorioExigenciaAnalitico}
              permissionsAllowed={['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-negocio-sprev',
              'gerenciar-negocio-dcomp', 'consultar-compensacao-rgps', 'consultar-compensacao-rpps', 'auditar-comprev',
              'analisar-negocio-dtpv']}
            />
            <PrivateRoute
              exact
              path="/repositorioctc/rpps/:acao(editar-rascunho|novo)"
              component={RepositorioCtc}
              permissionsAllowed={['requerer-compensacao-rpps']}
            />
            <PrivateRoute
              path="/consultaExtratoCnis/consulta-extrato"
              component={ConsultaExtratoCnis}
              permissionsAllowed={['analisar-negocio-dtpv']}
            />
            <PrivateRoute
              path="/repositorioctc/rpps/:cpf/:acao(editar-rascunho|novo)"
              component={RepositorioCtc}
              permissionsAllowed={['requerer-compensacao-rpps']}
            />
            <PrivateRoute
              path="/repositorioctc/rpps/:protocolo/:acao(detalhar-ctc|detalhar-ctc-invalida|revisar-ctc)"
              component={RepositorioCtc}
              permissionsAllowed={['requerer-compensacao-rpps']}
            />
            <PrivateRoute
              path="/repositorioctc/rpps/:protocolo/:situacao/:acao(detalhar-ctc|detalhar-ctc-invalida|revisar-ctc)"
              component={RepositorioCtc}
              permissionsAllowed={['requerer-compensacao-rpps']}
            />
            {/* Rotas possíveis para consulta de ctc */}
            <PrivateRoute
              exact
              path="/repositorioctc/consulta/:tipoConsulta(ctc)/:regime(rpps|rgps)"
              component={ConsultaRepositorioCtc}
              permissionsAllowed={['requerer-compensacao-rpps']}
            />
          </Switch>
        </DtpContent>
      </AuthenticationProvider>
      <Footer mensagem={props.configuracoesFrontend ? props.configuracoesFrontend.msgrodape : ''} />
      <DtpSnackbar />
    </React.Fragment>
  </Router>
);

App.defaultProps = {
  configuracoesFrontend: null,
};

App.propTypes = {
  configuracoesFrontend: PropTypes.arrayOf(PropTypes.string),
  showLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  showLoading: state.base.showLoading,
  configuracoesFrontend: state.base.configuracoesFrontend,
});

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.jsx